import axios from '@/services/axios-auth-wrapper';
import Q from 'q';
import moment from 'moment';

const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/netbase/';

// todo: consolidate topic cache variables
let topics;
let lastCachedTimestamp;
let currentlyProcessingApiRequest = false;
let currentPromise;

let themeCache = {
    topics: undefined,
    lastCachedTimestamp: undefined,
    currentlyProcessingApiRequest: false,
    currentPromise: undefined
};

// Here we have a client side caching for NetBase topic.
// As ES6 Modules are singletons we can store the cache in this module,
// and the same instance of this module will be used in all the imports.
export default {
    getTopics: (userId) => {
        // If there is currently a pending api request we shuld return the current pending promise and wait for the api request to complete,
        // rather than sending another api request and creating another promise.
        if (currentlyProcessingApiRequest && currentPromise && currentPromise.isFulfilled()) {
            return currentPromise;
        } else {
            let deferred = Q.defer();
            currentPromise = deferred.promise;

            // If the cached data is retrieved more than an hour ago, we need to clear the cache and update it by pulling the topics again from the api.
            if (lastCachedTimestamp && isMoreThanOneHourAgo(lastCachedTimestamp)) {
                topics = null;
            }

            // If there are cached topics we should return that rather than retrieving from the api.
            if (topics != null) {
                setTimeout(() => {
                    deferred.resolve(topics);
                }, 0);
            } else {
                axios.get(`${url}topics/${userId}`)
                    .then((result) => {
                        topics = result;
                        currentlyProcessingApiRequest = false;
                        lastCachedTimestamp = moment.utc();
                        deferred.resolve(topics);
                    },
                    (err) => {
                        currentlyProcessingApiRequest = false;
                        deferred.reject(err);
                    });
                currentlyProcessingApiRequest = true;
            }
            return currentPromise;
        }
    },
    getNetBaseAccessTokens: () => {
        return axios.get(`${url}tokens`);
    },
    getAllUsersWithoutAccessToken: () => {
        return axios.get(`${url}unassociated`);
    },
    deleteNetBaseAccessToken: (tokenId) => {
        return axios.delete(`${url}tokens/${tokenId}`);
    },
    deleteNetBaseAccessTokenUser: (tokenId, userId) => {
        return axios.delete(`${url}tokens/${tokenId}/users/${userId}`);
    },
    associateUsersWithAccessToken: (tokenId, userIds) => {
        return axios.post(`${url}tokens/${tokenId}/users`, userIds);
    },
    getThemes: (userId) => {
        // If there is currently a pending api request we shuld return the current pending promise and wait for the api request to complete,
        // rather than sending another api request and creating another promise.
        if (themeCache.currentlyProcessingApiRequest && themeCache.currentPromise && themeCache.currentPromise.isFulfilled()) {
            return themeCache.currentPromise;
        } else {
            let deferred = Q.defer();
            themeCache.currentPromise = deferred.promise;

            // If the cached data is retrieved more than an hour ago, we need to clear the cache and update it by pulling the topics again from the api.
            if (themeCache.lastCachedTimestamp && isMoreThanOneHourAgo(themeCache.lastCachedTimestamp)) {
                themeCache.themes = null;
            }

            // If there are cached topics we should return that rather than retrieving from the api.
            if (themeCache.themes != null) {
                setTimeout(() => {
                    deferred.resolve(themeCache.themes);
                }, 0);
            } else {
                axios.get(`${url}themes/${userId}`)
                    .then((result) => {
                        themeCache.themes = result;
                        themeCache.currentlyProcessingApiRequest = false;
                        themeCache.lastCachedTimestamp = moment.utc();
                        deferred.resolve(themeCache.themes);
                    },
                    (err) => {
                        themeCache.currentlyProcessingApiRequest = false;
                        deferred.reject(err);
                    });
                themeCache.currentlyProcessingApiRequest = true;
            }
            return themeCache.currentPromise;
        }
    }
};

function isMoreThanOneHourAgo (date) {
    let now = moment.utc();
    return (moment.utc(date).add(1, 'hours').isBefore(now));
}
